// Suprobion (S-Lab)
export const SUPROBION_STRAINS = [
  {
    id: "suprobion-humble-warrior",
    name: "Humble Warrior",
    producer: "Suprobion (S-Lab)",
    country: "Kanada",
    genetics: "Hybryda/Sativa",
    lineage: "MTF pochodna",
    thc: 23, cbd: 1.0,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Miętowy", "Skunk", "Sosnowy"],
    description: "Hybryda/sativa (60:40) działająca energetyzująco, aktywizująco i zmniejsza stan zapalny, co zawdzięcza ocymenowi i pinenowi. Kariofilen wykazuje działanie przeciwbólowe, do czego jest często stosowana. Mimo dominanty sativa zwykle jest określana jako odmiana oferująca \"spokojną energię\". Pacjenci zgłaszają szybką redukcję dolegliwości bólowych, działanie aktywizujące i wzrost energii bez otumanienia.",
    terpenes: { mircen: 32.0, kariofilen: 28.0, ocymen: 18.0, pinen: 12.0, limonen: 8.0, linalol: 2.0 },
    dominantTerpene: "Mircen", packaging: "10g"
  },
  {
    id: "suprobion-gorilla-glue",
    name: "Gorilla Glue",
    producer: "Suprobion (S-Lab)",
    country: "Kanada",
    genetics: "Hybryda/Indica",
    lineage: "Chem Sis × Sour Dubb × Chocolate Diesel",
    thc: 23, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Diesel", "Pikantny", "Sosnowy", "Ziemisty"],
    description: "Hybryda indica (65/35) o THC 23%. Powoduje intensywny relaks fizyczny, redukcję lęku i stresu, za co odpowiada dominujący kariofilen. Może nasilać łaknienie, szczególnie przy wyższych temperaturach waporyzacji. Pacjenci zgłaszają początkowe pobudzenie, przechodzące w wyciszenie i poprawę jakości snu oraz wzmożony apetyt.",
    terpenes: { kariofilen: 40.0, mircen: 10.0, limonen: 7.0, bisabolol: 7.0, humulen: 3.0 },
    dominantTerpene: "Kariofilen", packaging: "10g"
  },
  {
    id: "suprobion-mystic-wonder",
    name: "Mystic Wonder",
    producer: "Suprobion (S-Lab)",
    country: "Kanada",
    genetics: "Hybryda/Indica",
    lineage: "nieznany rodowód",
    thc: 23, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Cytrusowy", "Drzewny", "Owocowy", "Ziemisty"],
    description: "Hybryda/indica (60:40) o bogatym profilu terpenowym. Wykazuje działanie relaksujące i uspokajające, a także poprawiające jakość snu. Dzięki wysokiemu stężeniu THC i m.in. zawartości kariofilenu działa wspierająco w dolegliwościach bólowych.",
    terpenes: { mircen: 20, pinen: 20, kariofilen: 20, limonen: 20, farnezen: 20 },
    dominantTerpene: "Mircen", packaging: "10g"
  }
];